import { UMButton, UMIcon } from '../../urbanmap/_components';
import { PC, UMR, caption, card } from './tokens';
import { stationHistory } from './weather';
import type { WeatherStation } from './types';

interface Props {
  station: WeatherStation;
  selected: boolean;
  /** Position du point de la station, en pixels dans le conteneur de carte. */
  at: { x: number; y: number };
  onChoose: () => void;
  onClose: () => void;
}

const cell: React.CSSProperties = {
  padding: '3px 6px', fontSize: 12, textAlign: 'right', fontVariantNumeric: 'tabular-nums',
  borderBottom: `1px solid ${UMR.borderSubtle}`,
};
const head: React.CSSProperties = { ...cell, color: UMR.textSecondary, fontWeight: 400 };

/** Hauteur approximative de la fiche : sert à la basculer sous le point quand le haut manque. */
const CARD_H = 330;

/** Fiche d'une station météo, ancrée au point cliqué sur la carte : nom et degrés-jours. */
export function StationCard({ station, selected, at, onChoose, onClose }: Props) {
  const rows = stationHistory(station);
  const below = at.y < CARD_H;
  const tail = (
    <div style={{ width: 0, height: 0, margin: '0 auto', borderLeft: '8px solid transparent', borderRight: '8px solid transparent', [below ? 'borderBottom' : 'borderTop']: `8px solid ${UMR.white}`, filter: `drop-shadow(0 ${below ? -2 : 2}px 2px rgba(0,0,0,.18))` }} />
  );

  return (
    <div
      style={{
        position: 'absolute', left: at.x, top: below ? at.y + 16 : at.y - 16, zIndex: 6, width: 260,
        transform: below ? 'translate(-50%, 0)' : 'translate(-50%, -100%)', pointerEvents: 'auto',
      }}
    >
      {below && tail}
      <div style={{ ...card, display: 'flex', flexDirection: 'column', gap: 8, padding: 10, boxShadow: '0 2px 12px rgba(0,0,0,.18)' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6 }}>
          <UMIcon name="thermostat" size={18} color={PC.accent} />
          <strong style={{ flex: 1, fontSize: 14, lineHeight: '18px' }}>{station.name}</strong>
          <button type="button" aria-label="Fermer" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
            <UMIcon name="close" size={18} color={UMR.textSecondary} />
          </button>
        </div>

        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ ...head, textAlign: 'left' }}>Année</th>
              <th style={head}>DJU</th>
              <th style={head}>DJClim</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const std = r.year === null;
              return (
                <tr key={r.label} style={std ? { background: PC.accentBg } : undefined}>
                  <td style={{ ...cell, textAlign: 'left', fontWeight: std ? 700 : 400 }}>{r.label}</td>
                  <td style={{ ...cell, fontWeight: std ? 700 : 400 }}>{r.dju}</td>
                  <td style={{ ...cell, fontWeight: std ? 700 : 400 }}>{r.djclim}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {selected
          ? <div style={{ ...caption, display: 'flex', alignItems: 'center', gap: 6, color: PC.accentStrong }}><UMIcon name="check_circle" size={16} color={PC.accent} />Retenue pour le projet</div>
          : <UMButton icon="add" onClick={onChoose}>Ajouter au projet</UMButton>}
      </div>
      {!below && tail}
    </div>
  );
}
